import { createTheme } from "@mui/material/styles";
import { colorVariables } from "./colorVariable";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: colorVariables.primary },
    secondary: { main: "#e6004c" },
    background: { default: "#fff" },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: colorVariables.primary },
    secondary: { main: "#e6004c" },
    background: { default: "#121212" },
  },
});
